export const extractErrorData = (
  error: any
): { message: string; call: "premint" | "mint" | "unknown" } => {
  if (error?.cause.name.includes("UserRejectedRequestError")) {
    return {
      message: "User rejected wallet request",
      call: "premint"
    };
  }
  if (error?.cause.name.includes("User rejected the request")) {
    return {
      message: "User rejected wallet request",
      call: "premint"
    };
  }
  if (error?.cause.details.includes("Incorrect ETH Sent")) {
    return {
      message: "Incorrect ETH Sent",
      call: "premint"
    };
  }
  if (error?.cause.details.includes("insufficient funds")) {
    return {
      message:
        "Insufficient balance! Please make sure your wallet has enough to cover both the membership price and transaction fees.",
      call: "premint"
    };
  }

  return { message: "Transaction failed", call: "unknown" };
};
